import { Component } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { Estrategia } from "app/renda-variavel/models/estrategia.model";
import { EstrategiaService } from "app/renda-variavel/services/estrategia.service";
import { GeradorOrdemService } from "app/renda-variavel/services/gerador-ordem.service";
import { ActionDialog, BaseComponent } from "../../../base-module/base-component/base.component";
import { CadastroGeradorOrdemComponent } from "../cadastro-gerador-ordem/cadastro-gerador-ordem.component";

export interface Ordens {
    id: number;
    data_operacao: Date;
    user: any;
    estrategia: any;
    rotulo: string;
    tipo: string;
    qtd_boletas: number;
    vlr_financeiro: number;
    finalizada: boolean;
}

@Component({
    selector: "gerador-ordem",
    templateUrl: "./gerador-ordem-lista.component.html",
    styleUrls: ["./gerador-ordem-lista.component.scss"],
    animations: fuseAnimations,
})
export class GeradorOrdemListaComponent extends BaseComponent {
    user: any;

    listEstrategia: Estrategia[] = [];
    loadingSpinnerEstrategia!: boolean;
    filteredGerador: Array<Ordens> = [];
    primeiroDia = this._utilitesService.primeiroDiaMes();
    ultimoDia = this._utilitesService.ultimoDiaMes();

    estrategia_id = new FormControl("");

    data_operacao_inicio = new FormControl(this.primeiroDia);
    data_operacao_fim = new FormControl(this.ultimoDia);

    constructor(
        public _estrategiaService: EstrategiaService,
        private _utilitesService: UtilitesService,
        private _service: GeradorOrdemService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar
    ) {
        super(dialog, snackBar);
        this.getEstrategia();
        this.getAll();
    }

    getEstrategia() {
        this.loadingSpinnerEstrategia = true;

        this._estrategiaService.getLista().subscribe(
            (list) => {
                this.loadingSpinnerEstrategia = false;
                this.listEstrategia = list.data ?? [];
            },
            (error) => {
                this.loadingSpinnerEstrategia = false;
            },
            () => {
                this.loadingSpinnerEstrategia = false;
            }
        );
    }
    /**
     * Consulta lista de Boletas
     */
    getAll() {
        this.loadingIndicator = true;

        if (this.data_operacao_inicio.value != null) {
            this.params.data_inicio = this._utilitesService.formatDateToString(
                this.data_operacao_inicio.value ?? new Date()
            );
        }

        if (this.data_operacao_fim.value != null) {
            this.params.data_fim = this._utilitesService.formatDateToString(
                this.data_operacao_fim.value ?? new Date()
            );
        }

        this.params.estrategia_id = this.estrategia_id.value;

        this._service.getAll(this.params).subscribe(
            (data) => {
                this.filteredGerador = data.data;
            },
            (error) => {
                this.loadingIndicator = false;
            },
            () => {
                this.loadingIndicator = false;
            }
        );
    }
    /**
     * Exclui registro de boleta
     * @param id
     */
    delete(id: number) {
        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir Gerador de Ordem",
                text: "Deseja realmente excluir este item ?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.loadingIndicator = true;
                    lista._service.delete(id).subscribe(
                        (data) => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        (error) => {
                            lista.loadingIndicator = false;
                            lista.showError(error.error.message);
                        },
                        () => {
                            lista.loadingIndicator = false;
                        }
                    );
                },
            },
        });
    }

    openCadastro() {
        const dialogRef = this.dialog.open(CadastroGeradorOrdemComponent, {
            width: "400px",
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Gerador de Ordem cadastrado com sucesso!");
                this.getAll();
            }
        });
    }

    finalizaGerador(id: number) {
        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            data: {
                title: "Finalizar Gerador de Ordem",
                text: "Deseja realmente finalizar este gerador ?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.loadingIndicator = true;
                    lista._service.finalizaGerador(id).subscribe(
                        (data) => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        (error) => {
                            lista.loadingIndicator = false;
                            lista.showError(error.error.message);
                        },
                        () => {
                            lista.loadingIndicator = false;
                        }
                    );
                },
            },
        });
    }
}
